import React from 'react';
import { NavLink } from 'react-router-dom';
import { Map, BookOpen, ThumbsUp, User, Anchor } from 'lucide-react';
export function Sidebar() {
  const navItems = [{
    path: '/',
    icon: Map,
    label: 'Map'
  }, {
    path: '/rules',
    icon: BookOpen,
    label: 'Rules & Permits'
  }, {
    path: '/recommendations',
    icon: ThumbsUp,
    label: 'Recommendations'
  }, {
    path: '/profile',
    icon: User,
    label: 'Profile'
  }];
  return <aside className="hidden md:flex flex-col w-64 h-screen fixed left-0 top-0 bg-surface border-r border-border z-50" data-id="element-73">
      <div className="p-6 flex items-center space-x-3" data-id="element-74">
        <div className="bg-primary/10 p-2 rounded-xl" data-id="element-75">
          <Anchor className="w-6 h-6 text-primary" data-id="element-76" />
        </div>
        <span className="text-xl font-bold text-text tracking-tight" data-id="element-77">
          FishFinder
        </span>
      </div>

      <nav className="flex-1 px-4 space-y-2 mt-4" data-id="element-78">
        {navItems.map(item => <NavLink key={item.path} to={item.path} className={({
        isActive
      }) => `flex items-center space-x-3 px-4 py-3 rounded-xl transition-all duration-200 ${isActive ? 'bg-primary/10 text-primary font-medium' : 'text-text-muted hover:bg-gray-50 dark:hover:bg-slate-800 hover:text-text'}`} data-id="element-79">
            <item.icon size={20} data-id="element-80" />
            <span data-id="element-81">{item.label}</span>
          </NavLink>)}
      </nav>

      <div className="p-6 border-t border-border" data-id="element-82">
        <div className="flex items-center space-x-3" data-id="element-83">
          <div className="w-10 h-10 rounded-full bg-gray-200 dark:bg-slate-700 flex items-center justify-center text-text-muted" data-id="element-84">
            <User size={20} data-id="element-85" />
          </div>
          <div className="flex flex-col" data-id="element-86">
            <span className="text-sm font-medium text-text" data-id="element-87">Guest Angler</span>
            <span className="text-xs text-text-muted" data-id="element-88">Free Plan</span>
          </div>
        </div>
      </div>
    </aside>;
}